import { graphql, useLazyLoadQuery } from "react-relay"
import { useAgendaAppointmentByIdQuery as AgendaAppointmentByIdQuery } from "@/modules/waiting-room/services/__generated__/useAgendaAppointmentByIdQuery.graphql"

const agendaAppointmentQuery = graphql`
  query useAgendaAppointmentByIdQuery($id: ID!) {
    appointmentById(id: $id) {
      ...agendaAppointmentDrawer_appointment
    }
  }
`
export function useAgendaAppointmentByIdQuery(id: string) {
  const { appointmentById: appointment } = useLazyLoadQuery<AgendaAppointmentByIdQuery>(
    agendaAppointmentQuery,
    { id },
    {
      fetchPolicy: "store-or-network",
    },
  )
  return appointment
}
